import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './sales man.css'
import {message} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {NavLink, withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import {SearchOutlined} from '@ant-design/icons';

 
let csvData = [
  
];
class SalesMan extends React.Component {
  
  state={
    users:[],
    users2:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    collapsed: false,
    search:""
  }

  constructor(props){
    super(props)
    window.scrollTo(0,0)
    this.getUsersWithoutPagenation()
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    this.getUsers(1)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }


  getUsers = (page,refresh,search) =>{
    this.setState({loading:true})
    let url = ``
    if(search !== '' && search !== undefined){
      url = `${BASE_END_POINT}find?type=SALES-MAN&page=${page}&search=${search}`
    }else{
      url = `${BASE_END_POINT}find?type=SALES-MAN&page=${page}`
    }
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("USERS   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        item.fullname?item.fullname:'',
        item.img?{type:"img",img:item.img}:{type:"img",img:""},
        item.email?item.email:'',
        item.phone?item.phone:"",
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        users:response.data.data,
        users2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  getUsersWithoutPagenation = (page,refresh) =>{
    axios.get(`${BASE_END_POINT}withoutPagenation/get?type=SALES-MAN`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("USERS   ",response.data)
      csvData= response.data.map(item => {
        return {
          ...{id:item.id},
          ...{fullname:item.fullname?item.fullname:''},
          ...{email:item.email?item.email:""},
          ...{phone:item.phone},
        };
      });
      console.log(csvData)
      
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }

  deleteUser = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}/${id}/delete`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
       'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      console.log("Row DELETED")
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getUsers(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    })
 }

  addNewRecordButton = () =>(
    <div style={{width:'100%'}}>
      <NavLink to="addUser">
        <Fab
          style={{background:'#233b5b',float:'left',margin:'50px 30px'}}
          variant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )

  paginationButtons = () =>(
    <CardActions style={{display: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getUsers(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getUsers(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getUsers(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} 
        style={{color:`#233b5b !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getUsers(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getUsers(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    if (this.props.currentUser.user.type !== "ADMIN") return <Redirect to='/Home' />
    if(this.props.currentUser.user.type === "SALES-MAN") return <Redirect to='/Clients' />
    return (
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          
          <Table
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({search:null,type:null});this.getUsers(1,true);this.getUsersWithoutPagenation(true)}}
                class="material-icons">
                  replay
                </span>
                {/* <CSVLink 
                  data={this.state.csvData} 
                  headers={headers} 
                  filename={"users.csv"}
                  style={{padding: '10px',position: 'relative',top: '-5px'}}
                  >
                  <img crossOrigin="anonymous"alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                </CSVLink> */}
              </div>
              
            }
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass160':'hideClass'}>
                  <MDBRow>
                    <MDBCol xl="12" lg="12" md="12" sm="12">
                      <div class="md-form">
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.filterSearch}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol xl="12" lg="12" md="12" sm="12">
                      <Button style={{background: '#233b5b',color: '#fff',width: '100%',margin: '32px auto'}} 
                        onClick={()=>{this.getUsers(1);this.getUsersWithoutPagenation()}}><SearchOutlined /> {allStrings.Search}</Button>
                    </MDBCol>
                  </MDBRow>
                  
                </div>
              </div>
            }
            title={allStrings.adminsTable}
            icon='group'
            data={this.state.users}
            data2={this.state.users2}
            tableColumns={["#",allStrings.name,allStrings.img,allStrings.email,allStrings.phone,allStrings.action]}
            deleteButton={(id)=>{this.deleteUser(id)}}
            path='/UserInfo'
            actionIndex={8}
            />
            {this.paginationButtons()}
            {/*this.addNewRecordButton()*/}
              
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    
    );
  }

}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(SalesMan)
);

